<template>
  <div id="indicator-definitions" class="py-3">
    <ReportHeader
      :reportTypeId="reportTypeId"
      :title="title"
      :subtitle="subtitle"
    />

    <!-- head part of page page title/-->
    <div class="row">
      <!-- builds rows of indicator definitions -->
      <div class="col-large">
        <div
          v-for="(row, index) in indicatorDefinitions.evenRows"
          v-bind:key="index"
        >
          <div class="row pb-3">
            <div class="col-large">
              <label class="indicatorDefLabel">{{ row.Name }}</label>
              <p class="indicatorDef">{{ row.Definition }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-large">
        <div
          v-for="(row, index) in indicatorDefinitions.oddRows"
          v-bind:key="index"
        >
          <div class="row pb-3">
            <div class="col-large">
              <label class="indicatorDefLabel">{{ row.Name }}</label>
              <p class="indicatorDef">{{ row.Definition }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ReportHeader from '~/components/report/ReportHeader.vue';
  export default {
    name: 'DefinitionOfIndicatorsComponent',
    components: {
      ReportHeader,
    },
    props: {
      indicatorDefinitions: Object,
      isPDF: Boolean,
      reportDate: String,
      productType: String,
      reportTypeId: {
        type: [String, Number],
        // required: true,
      },
    },
    computed: {
      title() {
        return `Indicator Definitions`;
      },
      subtitle() {
        return ``;
      },
    },
  };
</script>
<style media="screen">
  .indicatorDef {
    background: #f9f9f9;
    padding: 0.5em;
    border: none;
    border-radius: 0px 0px 10px 10px;
  }

  .indicatorDefLabel {
    color: white;
    background: #183961;
    padding: 1em;
    margin-bottom: 0px;
    border-radius: 10px 10px 0px 0px;
  }
</style>
